module.exports = __webpack_public_path__ + "static/hunter-6a12846a1dc45522ed612cf64e24ae4d.webp";